import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Section from "./components/Section";
import About from "./components/About";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Blogs from "./components/Blogs";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";

function App() {
  return (
    <Router>
      <div className="relative overflow-x-hidden bg-brand-bg min-h-screen text-slate-100">
        <div className="fixed inset-0 -z-10 bg-gradient-to-br from-[#0b0d14] via-[#0d1221] to-black opacity-90" />
        <Navbar />

        <Routes>
          {/* Main Portfolio Page */}
          <Route
            path="/"
            element={
              <main>
                <Hero />

                <Section id="about" title="About Me">
                  <About />
                </Section>

                <Section id="projects" title="Featured Projects">
                  <Projects />
                </Section>

                <Section id="experience" title="Experience" centerTitle={false}>
                  <Experience />
                </Section>

                <Section id="skills" title="Core Skills">
                  <Skills />
                </Section>

                <Section id="education" title="Education">
                  <Education />
                </Section>

                <Section id="blogs" title="Blogs">
                  <Blogs />
                </Section>

                <Section id="contact" title="Let’s Connect">
                  <Contact />
                </Section>
              </main>
            }
          />

          {/* Blog List Page */}
          <Route path="/blog" element={<BlogList />} />

          {/* Individual Blog Page */}
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <footer className="mt-20 border-t border-white/10 pt-8 text-center text-sm text-slate-500">
          <div className="flex justify-center items-center gap-2 opacity-80 hover:opacity-100 transition">
            <img src="/neuralbrew.png" alt="NeuralBrew" className="h-5 w-auto" />
            <p>© {new Date().getFullYear()} NeuralBrew · Crafted by Devish Mundra</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
